var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.70509,
    y: 0.20509,
    width: 39.5898,
    height: 39.5898,
    rx: 19.7949,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.70509,
    y: 0.20509,
    width: 39.5898,
    height: 39.5898,
    rx: 19.7949,
    stroke: "url(#paint0_linear_88_17596)",
    strokeWidth: 0.41018
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.74025,
    y: 7.24035,
    width: 25.5193,
    height: 25.5193,
    rx: 12.7596,
    stroke: "url(#paint1_linear_88_17596)",
    strokeOpacity: 0.4,
    strokeWidth: 0.41018
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_17596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7834 19.5717H14.4103C13.7825 19.5717 13.2715 20.0824 13.2715 20.7103V26.0834C13.2715 26.7113 13.7825 27.2222 14.4103 27.2222H19.7834C20.4113 27.2222 20.922 26.7113 20.922 26.0834V20.7103C20.922 20.0824 20.4113 19.5717 19.7834 19.5717ZM19.5003 22.2706L16.6487 25.1219C16.4838 25.2873 16.2157 25.2877 16.0499 25.1219L14.6934 23.7657C14.5283 23.6002 14.5283 23.332 14.6934 23.1666C14.8589 23.0015 15.1271 23.0015 15.2925 23.1666L16.3494 24.2236L18.9012 21.6718C19.0666 21.5064 19.3348 21.5064 19.5003 21.6718C19.6654 21.837 19.6654 22.1052 19.5003 22.2706Z",
    fill: "url(#paint2_linear_88_17596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3263 17.2882V22.7019C24.3263 23.3185 23.8246 23.8204 23.2081 23.8204H21.7714V20.7103C21.7714 19.6155 20.8807 18.7248 19.7859 18.7248H16.6758V17.2882C16.6758 16.6716 17.1777 16.17 17.7943 16.17H23.208C23.8246 16.17 24.3263 16.6716 24.3263 17.2882Z",
    fill: "#CABCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7169 13.8963V19.31C27.7169 19.9266 27.2149 20.4282 26.5984 20.4282H25.1716V17.2882C25.1716 16.2047 24.29 15.323 23.2065 15.323H20.0664V13.8963C20.0664 13.2797 20.5681 12.7778 21.1846 12.7778H26.5984C27.2149 12.7778 27.7169 13.2797 27.7169 13.8963Z",
    fill: "#CABCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_88_17596",
    x1: 20.5,
    y1: 0,
    x2: 20.5,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9383F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_88_17596",
    x1: 20.4999,
    y1: 7.03526,
    x2: 20.4999,
    y2: 32.9647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9383F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_88_17596",
    x1: 20.922,
    y1: 23.397,
    x2: 13.2715,
    y2: 23.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A631FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#896DFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_17596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4444,
    height: 14.4444,
    fill: "white",
    transform: "translate(13.2773 12.7778)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockSelection);
export default __webpack_public_path__ + "static/media/stock-selection.9533514327f90ffd475e9eddb586b384.svg";
export { ForwardRef as ReactComponent };